
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-logout',
    imports: [
    MatCardModule
],
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutComponent { }
